import React from "react";
import { toast } from "react-toastify";
import { Modal, Button } from "@/Components/Common/Tailwind";
import { QRCodeSVG } from "qrcode.react";
import { API } from "../../api";
import { getAccessToken } from "../../api/auth";

type TicketInfo = {
  id: string | number;
  ticket_id?: string | number;
  name: string;
  ticket_state?: string;
  state?: string;
};

type QrResponse = {
  qr: string;
};

interface TicketGiftUseModalProps {
  setVisible: (value: boolean) => void;
  visible: boolean;
  info: TicketInfo;
  setInfo: (value: Partial<TicketInfo>) => void;
  needRefresh: () => void;
}

const TicketGiftUseModal: React.FC<TicketGiftUseModalProps> = ({
  setVisible,
  visible,
  info,
  setInfo,
  needRefresh,
}) => {
  const [checkQrCode, setCheckQrCode] = React.useState<string>("");

  const togModal = () => {
    setVisible(!visible);
    setCheckQrCode("");
  };

  const isGiftTicket = info.ticket_id !== undefined && info.ticket_id !== null;
  const displayTicketId = isGiftTicket ? info.ticket_id : info.id;
  const displayState = info.ticket_state ?? info.state ?? "";

  const changeTicket = async (): Promise<unknown> => {
    const accessToken = getAccessToken();

    try {
      const response = isGiftTicket
        ? await API.put(`/ticket/use-ticket-gift/${info.id}/`, null, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          })
        : await API.post(
            `/ticket/use-ticket/`,
            { id: info.id },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
            },
          );

      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getQrCode = async (): Promise<QrResponse> => {
    const accessToken = getAccessToken();

    try {
      const response = await API.get(`/ticket/ticket-qr/${displayTicketId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return (
    <React.Fragment>
      <Modal toggle={togModal} isOpen={visible} centered>
        <div>
          {/* qr코드 받아올 시에 그려야함 */}
          <div className="mb-4 flex justify-center">
            {checkQrCode ? (
              <QRCodeSVG value={checkQrCode} />
            ) : (
              <Button
                onClick={() => {
                  getQrCode().then((data) => {
                    console.log("qr data", data);
                    setCheckQrCode(data.qr);
                  });
                }}
                variant="primary"
              >
                QR 생성하기
              </Button>
            )}
          </div>
          <ul className="list-group">
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">티켓ID :</span>
              <span>{displayTicketId}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">티켓명 :</span>
              <span>{info.name}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">상태 :</span>
              <span>{displayState}</span>
            </li>
          </ul>
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="secondary"
            onClick={() => {
              setInfo({});
              setVisible(!visible);
              setCheckQrCode("");
            }}
          >
            닫기
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const confirmReserv = window.confirm("정말 사용하시겠습니까?");
              if (confirmReserv) {
                changeTicket()
                  .then((obj) => {
                    toast.success("티켓 상태가 변경되었습니다!");
                    setVisible(!visible);
                    // alert("예약 상태가 변경되었습니다! " + JSON.stringify(obj))
                    needRefresh();
                  })
                  .catch((error) => {
                    const message = error?.response?.data?.error || "티켓 상태 변경에 실패했습니다.";
                    toast.error(message);
                  });
              }
            }}
          >
            사용하기
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default TicketGiftUseModal;
